define('TescoMobile_Catalog/js/view/deal-device',['uiComponent', '../model/deal', 'ko', 'underscore', 'jquery', 'mage/translate', 'Magento_Catalog/js/price-utils', 'mage/url'], function (Component, deal, ko, _, $, $t, utils, url) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Catalog/deal-device',
      deviceSwatches: {},
      currentProductId: 0,
      optionMap: {},
      selectedSwatchOptions: {},
      deviceOptionSelector: false,
      tariffOptionSelector: false,
      tariffPreselected: false,
      mediaGallerySelector: '[data-gallery-role=gallery-placeholder]',
      stockAvailability: null,
      stockClass: null,
      optionUrl: '',
      stockAlertEnabled: false,
      memoryAttributeCode: 'tm_device_memory',
      colourAttributeCode: 'tm_device_marketing_colour',
      defaultStockStatusText: $t('In stock'),
      paygEnabled: false,
      simFreeEnabled: false,
      stockStatusMap: {
        0: $t('Currently out of stock'),
        1: $t('Limited stock'),
        2: $t('In stock')
      },
      addToCartButton: '.action.tocart',
      actionBarAddToCartButton: '.action-bar .action-button .primary',
      upgradeToCartButton: '.action.upgrade',
      tescoDotComProductUrl: '',
      oosAlertUrl: '',
      warehouseStockStatus: 0,
      deviceSku: null,
      seoUrlsEnabled: false,
      seoAttributes: new Map()
    },
    initialize: function () {
      this._super();
      this._setOptionSelectors();
      const colorValues = _.where(this.deviceSwatches, {
        attribute_code: this.colourAttributeCode
      });
      if (colorValues.length) {
        this.seoAttributes.set('color', colorValues[0].swatches.map(swatch => swatch.text_value));
      }
      const memoryValues = _.where(this.deviceSwatches, {
        attribute_code: this.memoryAttributeCode
      });
      if (memoryValues.length) {
        this.seoAttributes.set('memory', memoryValues[0].swatches.map(swatch => swatch.text_value));
      }
      this._setDefaults();
      $(document).on('selectDeviceOptionsEvent', $.proxy(this.selectDeviceOptionsAfterRender, this));
      $(document).on('tm:onProductTypeChange', $.proxy(this._updateOptionSelections, this));
      return this;
    },
    _priceFormat: function (price) {
      return utils.formatPrice(price);
    },
    selectDeviceOptionsAfterRender: function () {
      var selectedDeviceOption = this._getSelectedDeviceOption();
      this._selectDeviceOptions(selectedDeviceOption);
    },
    initObservable: function () {
      return this._super().observe(['stockAvailability', 'stockClass', 'deviceSku', 'warehouseStockStatus', 'oosAlertUrl', 'tariffPreselected', 'optionUrl']);
    },
    selectSwatch: function (swatch) {
      if (swatch.selected() == true) {
        return;
      }
      this._updateSwatches(swatch);
      this._updateOptionSelections();
      this._updateImageGallery();
    },
    _updateImageGallery: function () {
      let _self = this,
        imagesToUpdate = '',
        gallerySelector = $(this.mediaGallerySelector);
      let selectedDeviceOption = this._getSelectedDeviceOption();
      if (!_.isEmpty(selectedDeviceOption.images)) {
        imagesToUpdate = selectedDeviceOption.images;
      }
      if (gallerySelector.data('gallery')) {
        _self._insertGalleryImage(imagesToUpdate, selectedDeviceOption.selection_id);
      } else {
        gallerySelector.on('gallery:loaded', function () {
          _self._insertGalleryImage(imagesToUpdate, selectedDeviceOption.selection_id);
        });
      }
    },
    _insertGalleryImage: function (imagesToUpdate) {
      let gallery = $(this.mediaGallerySelector).data('gallery');
      if (!_.isUndefined(gallery) && !_.isEmpty(imagesToUpdate)) {
        gallery.updateData(imagesToUpdate);
      }
    },
    _updateSwatches: function (swatch) {
      var selections = this.optionMap.device.options.filter(function (mapping) {
        return mapping.attribute_code == swatch.attribute_code && mapping.attribute_value_id == swatch.attribute_value_id;
      });
      if (selections.length) {
        this.selectedSwatchOptions[swatch.attribute_code] = selections;
        this._updateSwatchStatus(swatch.attribute_code, selections);
      }
      this._updateSwatchSelection(swatch);
    },
    _updateSwatchStatus: function (attribute_code, selections) {
      var self = this,
        disabledAttributeIds = this._getDisabledAttributeIds(attribute_code, selections);
      _.each(this.deviceSwatches, function (deviceSwatch) {
        if (deviceSwatch.attribute_code != attribute_code) {
          _.each(deviceSwatch.swatches, function (swatch) {
            if (disabledAttributeIds.includes(swatch.attribute_value_id) && swatch.attribute_code !== self.memoryAttributeCode) {
              self.reSelectCurrentSwatch(swatch, disabledAttributeIds);
              swatch.enabled(false);
            } else {
              swatch.enabled(true);
            }
          });
        }
      });
    },
    reSelectCurrentSwatch: function (swatch, disabledAttributeIds) {
      var self = this,
        changed = false;
      if (swatch.selected()) {
        _.each(_.where(self.deviceSwatches, {
          attribute_code: swatch.attribute_code
        }), function (options, key) {
          _.each(options.swatches, function (option) {
            if (!disabledAttributeIds.includes(option.attribute_value_id) && !changed) {
              self.selectSwatch(option);
              changed = true;
            }
          });
        });
      }
    },
    _getDisabledAttributeIds: function (attribute_code, selections) {
      var activeOptionLinks = _.uniq(_.pluck(selections, 'option_link'));
      if (activeOptionLinks.length >= 1 && activeOptionLinks[0] === null) {
        activeOptionLinks = _.uniq(_.pluck(selections, 'sku'));
        var attributesInSameOption = this.optionMap.device.options.filter(function (mapping) {
          if (mapping.attribute_code == attribute_code) {
            return false;
          }
          return activeOptionLinks.includes(mapping.sku) == true;
        });
        var attributesNotInSameOption = this.optionMap.device.options.filter(function (mapping) {
          if (mapping.attribute_code == attribute_code) {
            return false;
          }
          return activeOptionLinks.includes(mapping.sku) == false;
        });
      } else {
        var attributesInSameOption = this.optionMap.device.options.filter(function (mapping) {
          if (mapping.attribute_code == attribute_code) {
            return false;
          }
          return activeOptionLinks.includes(mapping.option_link) == true;
        });
        var attributesNotInSameOption = this.optionMap.device.options.filter(function (mapping) {
          if (mapping.attribute_code == attribute_code) {
            return false;
          }
          return activeOptionLinks.includes(mapping.option_link) == false;
        });
      }
      var intersection = attributesNotInSameOption.filter(function (notInOption) {
        return !attributesInSameOption.some(function (inOption) {
          return inOption.attribute_value_id === notInOption.attribute_value_id;
        });
      });
      return _.uniq(_.pluck(intersection, 'attribute_value_id'));
    },
    _updateSwatchSelection: function (swatch) {
      var _self = this;
      _.each(_.where(this.deviceSwatches, {
        attribute_code: swatch.attribute_code
      }), function (deviceSwatch) {
        _.each(deviceSwatch.swatches, function (sameAttributeSwatch) {
          if (sameAttributeSwatch.attribute_value_id == swatch.attribute_value_id) {
            sameAttributeSwatch.selected(true);
          } else {
            sameAttributeSwatch.selected(false);
          }
        });
      });
    },
    _getUrlParam: function (type) {
      const url = new URL(window.location.href);
      return this.seoUrlsEnabled && this.seoAttributes.has(type) ? _.intersection(this.seoAttributes.get(type), url.pathname.split('/')).pop() : url.searchParams.get(type);
    },
    _getSelectedAttributeValue: function (attributeCode) {
      var _attribute$swatches$f;
      const attribute = this.deviceSwatches.find(swatch => swatch.attribute_code === attributeCode);
      if (!attribute) {
        return;
      }
      return (_attribute$swatches$f = attribute.swatches.find(swatch => swatch.selected())) === null || _attribute$swatches$f === void 0 ? void 0 : _attribute$swatches$f.text_value;
    },
    _updateOptionSelections: function () {
      var selectedDeviceOption = this._getSelectedDeviceOption();
      deal.isUpdatingOptions = false;
      $(document).on('DynamicOptionsPriceUpdateBefore');
      if (selectedDeviceOption != false) {
        deal.isUpdatingOptions = true;
        this._clearAllOptions();
        this._selectTariffOptions(selectedDeviceOption);
        deal.isUpdatingOptions = false;
        this._selectDeviceOptions(selectedDeviceOption);
      }
      if (Object.keys(this.selectedSwatchOptions).length) {
        this._updateAddToCartButton(selectedDeviceOption);
        this._updateStockMessage(selectedDeviceOption);
      }
      if (this.paygEnabled) {
        this._updatePaygBlocks(selectedDeviceOption);
      }
      if (this.simFreeEnabled) {
        this._updateSimFreeBlocks(selectedDeviceOption);
      }
      this.getAlertUrl();
    },
    _updateSimFreeBlocks: function (selectedDevice) {
      let priceElement = $('.sim-price-update .custom-price-container.regular-price .price'),
        oldPriceElement = $('.sim-free-add-to-cart-btn .custom-price-container.old-price'),
        eanElement = $('.add-to-cart-custom-wrapper .ean-number'),
        paygTypeSwitcher = $('.swatch-option-item.pay-as-you-go'),
        paymTypeSwitcher = $('.swatch-option-item.pay-monthly'),
        simFreeTypeSwitcher = $('.swatch-option-item.sim-free');
      if (!_.isEmpty(selectedDevice.sim_free_data)) {
        if (!_.isEmpty(selectedDevice.sim_free_data.prices)) {
          if (selectedDevice.sim_free_data.prices.regular !== null && selectedDevice.sim_free_data.prices.regular > 0) {
            priceElement.html(this._priceFormat(selectedDevice.sim_free_data.prices.regular));
            simFreeTypeSwitcher.removeClass('disabled');
            if (selectedDevice.sim_free_data.prices.special !== '') {
              oldPriceElement.find('.price').html(this._priceFormat(selectedDevice.sim_free_data.prices.special));
              oldPriceElement.show();
            } else {
              oldPriceElement.hide();
            }
          } else {
            $(document).trigger('tm:paygDeviceUnavailible');
            paymTypeSwitcher.addClass('selected');
            paygTypeSwitcher.addClass('disabled').removeClass('selected');
            simFreeTypeSwitcher.addClass('disabled').removeClass('selected');
          }
        }
        if (!_.isEmpty(selectedDevice.sim_free_data.ean)) {
          eanElement.attr('href', this.tescoDotComProductUrl + selectedDevice.sim_free_data.ean);
        }
      } else {
        if ($('.swatch-option-item.pay-as-you-go.selected').length === 0) {
          paymTypeSwitcher.trigger('click');
        }
        if (_.isEmpty(selectedDevice.payg_data) && _.isEmpty(selectedDevice.payg_data.prices)) {
          paygTypeSwitcher.addClass('disabled').removeClass('selected');
        }
        simFreeTypeSwitcher.addClass('disabled').removeClass('selected');
      }
    },
    _updatePaygBlocks: function (selectedDevice) {
      let priceElement = $('.payg-price-update .custom-price-container.regular-price .price'),
        oldPriceElement = $('.payg-add-to-cart-btn .custom-price-container.old-price'),
        eanElement = $('.add-to-cart-custom-wrapper .ean-number'),
        paygTypeSwitcher = $('.swatch-option-item.pay-as-you-go'),
        paymTypeSwitcher = $('.swatch-option-item.pay-monthly'),
        simFreeTypeSwitcher = $('.swatch-option-item.sim-free');
      if (!_.isEmpty(selectedDevice.payg_data)) {
        if (!_.isEmpty(selectedDevice.payg_data.prices)) {
          if (selectedDevice.payg_data.prices.regular !== null && selectedDevice.payg_data.prices.regular > 0) {
            priceElement.html(this._priceFormat(selectedDevice.payg_data.prices.regular));
            paygTypeSwitcher.removeClass('disabled');
            if (selectedDevice.payg_data.prices.special !== '') {
              oldPriceElement.find('.price').html(this._priceFormat(selectedDevice.payg_data.prices.special));
              oldPriceElement.show();
            } else {
              oldPriceElement.hide();
            }
          } else {
            $(document).trigger('tm:paygDeviceUnavailible');
            paymTypeSwitcher.addClass('selected');
            paygTypeSwitcher.addClass('disabled').removeClass('selected');
            if (_.isEmpty(selectedDevice.sim_free_data) && _.isEmpty(selectedDevice.sim_free_data.prices)) {
              simFreeTypeSwitcher.addClass('disabled').removeClass('selected');
            }
          }
        }
        if (!_.isEmpty(selectedDevice.payg_data.ean)) {
          eanElement.attr('href', this.tescoDotComProductUrl + selectedDevice.payg_data.ean);
        }
      } else {
        $(document).trigger('tm:paygDeviceUnavailible');
        if ($('.swatch-option-item.pay-monthly.selected').length === 0 && $('.swatch-option-item.sim-free.selected').length === 0) {
          paymTypeSwitcher.trigger('click');
        }
        paygTypeSwitcher.addClass('disabled').removeClass('selected');
      }
    },
    _updateStockMessage: function (option) {
      const status = option ? option.stock_status : 0;
      this.stockAvailability(status in this.stockStatusMap ? this.stockStatusMap[status] : this.defaultStockStatusText);
      this.stockClass(this._getStockClass(status));
      this.warehouseStockStatus(status);
      var oosLink = option.product_alert_stock_add_url;
      this.optionUrl(oosLink);
    },
    getAlertUrl: function () {
      if (this.optionUrl() && this.stockClass() === 'oos') {
        let alertUrl = url.build(this.optionUrl());
        this.oosAlertUrl(alertUrl);
      } else {
        this.oosAlertUrl('');
      }
    },
    _clearAllOptions: function () {
      $(this.deviceOptionSelector + ' option').attr('disabled', true);
      $(this.tariffOptionSelector).attr('disabled', true).parent().removeClass('visible');
    },
    _selectDeviceOptions: function (selectedDeviceOption) {
      var deviceSelections = _.pluck(_.where(this.optionMap.device.options, {
        option_link: selectedDeviceOption.option_link
      }), 'selection_id');
      _.each($(this.deviceOptionSelector + ' option'), function (option) {
        if (_.contains(deviceSelections, $(option).val())) {
          $(option).attr('disabled', false);
        }
      });
      $(this.deviceOptionSelector).val(selectedDeviceOption.selection_id).trigger('change');
      this.deviceSku(selectedDeviceOption.sku);
    },
    getMatches: function (query, property, arr) {
      if (typeof query === 'undefined' || !query) {
        return [];
      }
      var lowerQuery = query.toLowerCase();
      return _.filter(arr, function (term) {
        return term[property].toLowerCase() == lowerQuery;
      });
    },
    _selectTariffOptions: function (selectedDeviceOption) {
      if (this.optionMap.tariff.options.length === 1) {
        deal.selectedTariffSku = this.optionMap.tariff.options[0].sku;
        deal.tariffSelectionValue = this.optionMap.tariff.options[0].selection_id;
        $(this.tariffOptionSelector).attr('disabled', false).parent().addClass('visible');
      } else {
        var tariffSelections = _.where(this.optionMap.tariff.options, {
          option_link: selectedDeviceOption.option_link
        });
        if (this._getUrlParam('tariff') && typeof this.getMatches(this._getUrlParam('tariff'), 'allowance_data', tariffSelections) !== 'undefined') {
          this.tariffPreselected(true);
        }
        $(this.tariffOptionSelector).attr('checked', false);
        _.each($(this.tariffOptionSelector), function (option) {
          _.each(tariffSelections, function (tariffSelection) {
            if ($(option).val() == tariffSelection.selection_id) {
              $(option).attr('disabled', false).parent().addClass('visible');
              if (deal.tariffSelectionValue !== '') {
                var isSelectedTariffExist = _.findWhere(tariffSelections, {
                  selection_id: deal.tariffSelectionValue
                });
              }
              if (typeof isSelectedTariffExist !== 'undefined') {
                if ($(option).val() == deal.tariffSelectionValue) {
                  $(option).attr('checked', true).trigger('change');
                  deal.selectedTariffSku = tariffSelection.sku;
                }
              } else {
                if (this.tariffPreselected() && tariffSelection.allowance_data.toLowerCase() === this._getUrlParam('tariff').toLowerCase()) {
                  $(option).attr('checked', true).trigger('change');
                  deal.selectedTariffSku = tariffSelection.sku;
                } else if (!this.tariffPreselected() && tariffSelection.default_selection === true) {
                  $(option).attr('checked', true).trigger('change');
                  deal.selectedTariffSku = tariffSelection.sku;
                }
              }
            }
          }, this);
        }, this);
      }
    },
    _getSelectedDeviceOption: function () {
      var selectedDeviceOption = false;
      _.each(this.selectedSwatchOptions, function (swatchOption, attributeCode) {
        if (attributeCode === false) {
          return false;
        }
      });
      if (Object.keys(this.selectedSwatchOptions).length == 1) {
        return this.selectedSwatchOptions[Object.keys(this.selectedSwatchOptions)[0]][0];
      }
      _.each(this.selectedSwatchOptions, function (swatchOptions) {
        _.each(swatchOptions, function (swatchOption) {
          _.each(this.selectedSwatchOptions, function (swatchOptions2) {
            _.each(swatchOptions2, function (swatchOption2) {
              if (swatchOption !== swatchOption2 && swatchOption.selection_id === swatchOption2.selection_id) {
                selectedDeviceOption = swatchOption;
              }
            });
          });
        }, this);
      }, this);
      return selectedDeviceOption;
    },
    _getStockClass: function (status) {
      if (status === 0) {
        return 'oos';
      } else if (status === 1) {
        return 'limited';
      } else {
        return 'in-stock';
      }
    },
    _setOptionSelectors: function () {
      if (this.optionMap.device.option_id) {
        this.deviceOptionSelector = '#bundle-option-' + this.optionMap.device.option_id;
        if ($(this.deviceOptionSelector).length === 0) {
          this.deviceOptionSelector = 'input[name="bundle_option[' + this.optionMap.device.option_id + ']"]';
        }
      }
      if (this.optionMap.tariff.option_id) {
        this.tariffOptionSelector = 'input[name="bundle_option[' + this.optionMap.tariff.option_id + ']"]';
      }
    },
    _setDefaults: function () {
      var defaultSwatches = [],
        _self = this,
        colorValues = _.where(this.deviceSwatches, {
          attribute_code: 'tm_device_marketing_colour'
        }),
        memoryValues = _.where(this.deviceSwatches, {
          attribute_code: 'tm_device_memory'
        }),
        selectedColour = this._getUrlParam('color'),
        selectedMemory = this._getUrlParam('memory'),
        colorExist = colorValues.length > 0 && colorValues[0].swatches.length > 0 && _self.getMatches(selectedColour, 'text_value', colorValues[0].swatches).length > 0,
        memoryExist = memoryValues.length > 0 && memoryValues[0].swatches.length > 0 && _self.getMatches(selectedMemory, 'text_value', memoryValues[0].swatches).length > 0;
      _.each(this.deviceSwatches, function (option) {
        this.selectedSwatchOptions[option.attribute_code] = false;
        _.each(option.swatches, function (swatch) {
          swatch.enabled = ko.observable(true);
          swatch.selected = ko.observable(false);
          if (selectedColour && selectedMemory && colorExist && memoryExist) {
            if (swatch.attribute_code === this.colourAttributeCode && swatch.text_value.toLowerCase() == selectedColour.toLowerCase()) {
              defaultSwatches.push(swatch);
            } else if (selectedMemory && swatch.attribute_code === this.memoryAttributeCode && swatch.text_value.toLowerCase() == selectedMemory.toLowerCase()) {
              defaultSwatches.push(swatch);
            }
          } else if (selectedColour && !selectedMemory && colorExist) {
            if (swatch.attribute_code === this.colourAttributeCode && swatch.text_value.toLowerCase() == selectedColour.toLowerCase()) {
              defaultSwatches.push(swatch);
            }
          } else if (!selectedColour && selectedMemory && memoryExist) {
            if (swatch.attribute_code === this.memoryAttributeCode && swatch.text_value.toLowerCase() == selectedMemory.toLowerCase()) {
              defaultSwatches.push(swatch);
            }
          } else if (swatch.default_selection == true) {
            defaultSwatches.push(swatch);
          }
        }, this);
        if (_.where(defaultSwatches, {
          attribute_code: option.attribute_code
        }).length === 0) {
          defaultSwatches.push(_.where(option.swatches, {
            attribute_code: option.attribute_code
          })[0]);
        }
      }, this);
      _.each(defaultSwatches, function (defaultSwatch) {
        this._updateSwatches(defaultSwatch);
      }, this);
      this._updateOptionSelections();
      this._updateImageGallery();
    },
    _updateAddToCartButton: function (selectedDeviceOption) {
      if (selectedDeviceOption.stock_status) {
        $(this.addToCartButton).removeClass('disabled');
        $(this.upgradeToCartButton).removeClass('disabled');
        $(this.actionBarAddToCartButton).removeClass('disabled');
      } else {
        $(this.addToCartButton).addClass('disabled');
        $(this.upgradeToCartButton).addClass('disabled');
        $(this.actionBarAddToCartButton).addClass('disabled');
      }
    }
  });
});

